"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "setupUserProvider", {
  enumerable: true,
  get: function () {
    return _utils.setupUserProvider;
  }
});
var _utils = require("./utils");
